import * as React from 'react';
import {
  defineDataset,
  EDatasetColors,
  EDatasetColorTypes,
  filterTicksVarA,
  getTooltipTitleVarA,
  TChartFactoryProps,
} from '@cian/react-chartjs-component';
import { getPrettyPrice } from '@cian/valuation-utils-component';
import { path } from 'ramda';
import { useSelector } from 'react-redux';

import { ROUBLE_SIGN } from '../../../../../constants/symbols';

import { selectDeveloperValuationData } from '../../../../../selectors/developerValuation';
import { IDeveloperValuationChart } from '../../../../../types/developerValuation/developerValuationChart';
import { LABELS_COUNT } from '../../../../../constants/pricesDynamics';

export const useDynamicPricesChartCfg = (): TChartFactoryProps | null => {
  const valuation = useSelector(selectDeveloperValuationData);
  const priceUnit = ROUBLE_SIGN;

  return React.useMemo(() => {
    if (!valuation?.chart) {
      return null;
    }

    const chartData: IDeveloperValuationChart[] = valuation.chart;
    const values = chartData.map(item => item.value);
    const labels = chartData.map(item => item.date);
    const maxChartValue = Math.max(...values);
    const minChartValue = Math.min(...values);
    const labelStep = Math.abs(maxChartValue - minChartValue) / (LABELS_COUNT - 1);

    const line = defineDataset({
      data: values,
      color: EDatasetColors.BLUE,
      colorType: EDatasetColorTypes.GRADIENT,
    });

    return {
      chartHeight: 220,
      datasetCfgCreators: [line],
      chartCfgParams: {
        chartType: 'line',
        labelsData: labels,
        yMaxVal: maxChartValue,
        yMinVal: minChartValue,
        yValStep: labelStep,
        xAfterTickToLabelConversion: filterTicksVarA,
        xGridLinesColor: 'transparent',
        tooltipTitleCb: getTooltipTitleVarA,
        tooltipLabelCb: (tooltipItem, data) => {
          try {
            const originValue = path(['datasets', tooltipItem.datasetIndex, 'data', tooltipItem.index], data) as number;

            return `Средняя цена ${getPrettyPrice(originValue, { unit: priceUnit })}`;
          } catch (e) {
            return '';
          }
        },
        yTicksCb: val =>
          getPrettyPrice(Number(val), {
            showUnit: false,
            showPostfix: false,
          }),
      },
    };
  }, [valuation, priceUnit]);
};
